import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Select, { type MenuPlacement } from 'react-select';

import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import type { Criteria } from 'bundles/connect/types';

type MultiSelectDropdownProps = {
  extraClassNames?: string;
  criteria: Criteria;
  disabled?: boolean;
  attribute?: string;
  isMulti?: boolean;
  menuPlacement?: MenuPlacement;
  options: { value: string | number; label: string }[];
  setFilterAttribute: (attribute: string, value: string | null, options?: any) => { type: string } | undefined;
  onChangeCallback?: (selectedOptions: any) => void;
}

function MultiSelectDropdown({
  extraClassNames = '',
  criteria,
  attribute = '',
  isMulti,
  menuPlacement,
  options,
  disabled = false,
  setFilterAttribute,
  onChangeCallback
}: MultiSelectDropdownProps) {
  const handleChange = (selectedOptions) => {
    if (isMulti) {
      if (selectedOptions.length > 0) {
        setFilterAttribute(attribute, selectedOptions.map(option => option.value));
      } else {
        setFilterAttribute(attribute, null);
      }
    } else {
      setFilterAttribute(attribute, selectedOptions?.value);
    }

    onChangeCallback && onChangeCallback(selectedOptions);
  };

  const selectValue = () => {
    if (isMulti) {
      return options.filter(option => (criteria[attribute] || []).includes(option.value));
    } else {
      return criteria[attribute] ?
        {
          value: criteria[attribute],
          label: options.find(option => option.value === criteria[attribute])?.label || criteria[attribute]
        } : null;
    }
  };

  return (
    <Select
      className={classNames('as-button', criteria[attribute] ? 'active' : 'text-muted', extraClassNames)}
      isClearable
      isDisabled={disabled}
      isMulti={isMulti}
      menuPlacement={menuPlacement || 'auto'}
      options={options}
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      value={selectValue()}
      onChange={handleChange}
    />
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(MultiSelectDropdown);
